import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-dee26278.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-29aac069.js';
import { f as focusPseudoElementsAfter } from '../FocusIndicator/styleMixins/focusPseudoElementsAfter-2ee458b5.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-701df069.js';
import { T as TouchLinkGroup } from './TouchLinkGroup/TouchLinkGroup-12cc9c44.js';
import { I as Icon } from '../Icon/Icon-e4f870d4.js';

const TouchLinkContainerStyle = /*#__PURE__*/css(["color:", ";cursor:pointer;display:block;font-size:", ";position:relative;text-decoration:none;width:100%;:active,:link,:visited{color:", ";text-decoration:none;}:hover{color:", ";text-decoration:none;}:focus{outline:none;}", ""], ({
  theme
}) => theme.touchLink.color, ({
  theme
}) => theme.touchLink.fontSize, ({
  theme
}) => theme.touchLink.color, ({
  theme
}) => theme.touchLink.color, isMobile(css(["font-size:", ";"], ({
  theme
}) => theme.touchLink.mobile.fontSize)));
const TouchLinkAnchor = /*#__PURE__*/styled('a').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible
  };
}).withConfig({
  componentId: "sc-storm-ui-30045578__sc-1b2ofiz-0"
})(["", " ", ""], TouchLinkContainerStyle, ({
  focusVisible
}) => focusVisible && focusPseudoElementsAfter);
const TouchLinkContent = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30045578__sc-1b2ofiz-1"
})(["background-color:", ";border:1px solid ", ";border-radius:", ";padding-top:", ";padding-bottom:", ";padding-inline-start:", ";padding-inline-end:38px;position:relative;", " &{border:none;}"], ({
  theme
}) => theme.touchLink.backgroundColor, ({
  theme
}) => theme.touchLink.borderColor, ({
  theme
}) => theme.touchLink.borderRadius, ({
  theme
}) => theme.spacing.base, ({
  theme
}) => theme.spacing.base, ({
  theme
}) => theme.spacing.medium, TouchLinkGroup);
const TouchLinkButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    /*
     *`useFocusRing()` uses `onFocus` and `onBlur` props, so `mergeProps()` must be used to
     * make sure user supplied `onFocus` and `onBlur` are also called.
    */
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30045578__sc-1b2ofiz-2"
})(["all:unset;border-radius:", ";", " ", ""], ({
  theme
}) => theme.touchLink.borderRadius, TouchLinkContainerStyle, ({
  focusVisible
}) => focusVisible && focusPseudoElementsAfter);
const TouchLinkIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30045578__sc-1b2ofiz-3"
})(["color:", ";margin-top:-9px;position:absolute;top:50%;left:auto;inset-inline-start:auto;right:18px;inset-inline-end:18px;[dir=\"rtl\"] &&{right:auto;inset-inline-start:auto;left:18px;inset-inline-end:18px;}", ""], ({
  theme
}) => theme.touchLink.iconColor, isMobile(css(["margin-top:-11px;"])));

export { TouchLinkButton as T, TouchLinkAnchor as a, TouchLinkContent as b, TouchLinkIcon as c };
//# sourceMappingURL=TouchLink.styles-5287b479.js.map
